<template lang="pug">
  div
    .form-group
      button.btn.btn-primary(@click="openUpgradeModal") 只今準備中です...
    .form-group
      a(href="https://sitelead.notion.site/18aa1f34e38c8012a8f8d3ca218a7bb7", target="_blank") 利用規約
    .form-group
      a(href="https://sitelead.notion.site/18aa1f34e38c802c8c29e98e2eed623e", target="_blank") 利用マニュアル
    upgrade-upper-master(v-if="showUpgradeModal" @close-modal="closeUpgradeModal")
</template>

<script>
import UpgradeUpperMaster from "./modals/upgrade_upper_master.vue";

export default {
  components: {
    UpgradeUpperMaster
  },
  data() {
    return {
      showUpgradeModal: false
    }
  },
  methods: {
    openUpgradeModal() {
      //this.showUpgradeModal = true;
    },
    closeUpgradeModal() {
      this.showUpgradeModal = false;
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
